import { map, path } from 'ramda';

export const mapLabelValue = (options) =>
  map(
    (option) => ({
      label: path([0], option),
      value: path([1], option)
    }),
    options
  );

export const mapLabelValueBadge = (options) =>
  map(
    (option) => ({
      label: path([0], option),
      value: path([1], option),
      badge: path([2], option)
    }),
    options
  );
